<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { sendFandomAnalyticsEvent }  from 'src/modules/fandom_analytics_module.js';

export default {
  mixins: [ fandomBasicMixin ],
  props: {
    identifier: {
      type: String,
      default: '',
    },
  },
  data() {
    return { }
  },
  mounted() {
    Vue.nextTick(() => {
      setTimeout(() => {
        this.openModal()
      }, this.content.time_out || 3000);
    });
  },
  methods: {
    openModal() {
      $("#" + this.identifier).modal("show");
      sendFandomAnalyticsEvent('Talent modal', 'Show', null);
    },
    closeModal() {
      $("#" + this.identifier).modal("hide");
      $("#" + this.identifier).removeClass("modal");
      $(".modal-backdrop").remove();
    },
    trackingUrl(event, category, action, label) {
      sendFandomAnalyticsEvent(category, action, label);
      window.location.href = $(event.currentTarget).attr('href');
      return false;
    }
  },
};
</script>

<template>
  <div
    v-if="isContentVisibleToUser()"
    :id="identifier"
    class="modal fade"
    modal-collection-recipes-component
  >
    <div class="modal-dialog modal-dialog-centered mx-3 mx-sm-auto">
      <div class="modal-content">
        <div class="modal-body p-4 p-sm-5">
          <button class="close modal-close-icon" data-dismiss="modal" data-backdrop="false" @click="closeModal()" aria-label="Close">
            <i class="fal fa-times" style="font-size: 1.25rem;"></i>
          </button>
          <div class="d-flex flex-column justify-content-center align-items-center text-center">
            <img class="image mb-4" :src="content.image.url">
            <h2 class="h6 last-child-margin-0 mb-0" v-html="content.title"></h2>
            <p class="small last-child-margin-0 mt-3 mb-0" v-html="content.description"></p>
            <a
              v-if="content.button"
              class="btn mt-3"
              :href="content.button.url"
              :class="content.button_class ? content.button_class : 'btn-cheddar'"
              @click.prevent="trackingUrl($event, 'Talent modal', 'Button click', content.button.title)"
            >{{ content.button.title }}</a>
            <a
              v-if="content.url"
              class="text-center text-dark text-uppercase small mt-3"
              :href="content.url.url"
              @click.prevent="trackingUrl($event, 'Talent modal', 'Button click', content.url.title)"
            >{{ content.url.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[modal-collection-recipes-component] {

  &.modal {
    .modal-dialog {
      transition: transform 0.3s ease-out, max-width 0.25s, height 0.25s !important;
    }

    .modal-body {
      .close-icon {
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .image {
      max-width: 100%;
      max-height: 18rem;
    }

    .last-child-margin-0 p:last-child {
      margin-bottom: 0 !important;
    }

    .btn {
      padding: 0.7rem;
      width: 100%;
    }
  }
}
</style>